import { createContext } from "react";

export const DATE_OVERRIDE_STORAGE_KEY = "dev.dateOverride";

export interface DateOverrideValues {
  day1Date: string;
  signingDate: string;
  targetCompletionDate: string;
}

export interface DateOverrideContextValue extends DateOverrideValues {
  setField: (field: keyof DateOverrideValues, value: string) => void;
  clearAll: () => void;
  hasOverrides: boolean;
}

export const EMPTY_DATE_OVERRIDE: DateOverrideValues = {
  day1Date: "",
  signingDate: "",
  targetCompletionDate: "",
};

export function loadDateOverrides(): DateOverrideValues {
  if (typeof window === "undefined") return EMPTY_DATE_OVERRIDE;
  try {
    const stored = localStorage.getItem(DATE_OVERRIDE_STORAGE_KEY);
    if (!stored) return EMPTY_DATE_OVERRIDE;
    const parsed = JSON.parse(stored) as Partial<DateOverrideValues>;
    return {
      day1Date: parsed.day1Date ?? "",
      signingDate: parsed.signingDate ?? "",
      targetCompletionDate: parsed.targetCompletionDate ?? "",
    };
  } catch {
    return EMPTY_DATE_OVERRIDE;
  }
}

export const DateOverrideContext = createContext<DateOverrideContextValue | null>(null);
